function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import { instrumentMethod } from '../../tools/instrumentMethod';
import { clocksNow } from '../../tools/utils/timeUtils';
import { computeStackTrace, computeStackTraceFromOnErrorMessage } from '../../tools/stackTrace/computeStackTrace';
import { computeRawError, isError } from './error';
import { ErrorSource } from './error.types';
export function trackRuntimeError(errorObservable) {
  var handleRuntimeError = function handleRuntimeError(stackTrace, originalError) {
    var rawError = computeRawError({
      stackTrace: stackTrace,
      originalError: originalError,
      startClocks: clocksNow(),
      nonErrorPrefix: "Uncaught"
      /* NonErrorPrefix.UNCAUGHT */
      ,
      source: ErrorSource.SOURCE,
      handling: "unhandled"
      /* ErrorHandling.UNHANDLED */

    });
    errorObservable.notify(rawError);
  };

  var _instrumentOnError = instrumentOnError(handleRuntimeError),
      stopInstrumentingOnError = _instrumentOnError.stop;

  var _instrumentUnhandledR = instrumentUnhandledRejection(handleRuntimeError),
      stopInstrumentingOnUnhandledRejection = _instrumentUnhandledR.stop;

  return {
    stop: function stop() {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    }
  };
}
export function instrumentOnError(callback) {
  return instrumentMethod(window, 'onerror', function (_ref) {
    var _ref$parameters = _slicedToArray(_ref.parameters, 5),
        messageObj = _ref$parameters[0],
        url = _ref$parameters[1],
        line = _ref$parameters[2],
        column = _ref$parameters[3],
        errorObj = _ref$parameters[4];

    var stackTrace;

    if (isError(errorObj)) {
      stackTrace = computeStackTrace(errorObj);
    } else {
      stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
    }

    callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
  });
}
export function instrumentUnhandledRejection(callback) {
  return instrumentMethod(window, 'onunhandledrejection', function (_ref2) {
    var _ref2$parameters = _slicedToArray(_ref2.parameters, 1),
        e = _ref2$parameters[0];

    var reason = e.reason || 'Empty reason';
    var stack = computeStackTrace(reason);
    callback(stack, reason);
  });
}